import {
    apiRequest,
    masterCategories,
    acmanajerialDetail,
    acmanajerialLevel,
    acmanajerialUpdate
} from "../../../../../services/adapters/kepegawaian/Accompetence"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", acmanajerialDetail, {
            params: query
        }, true)
    }

    fetchLevel = async (query) => {
        return await apiRequest("get", acmanajerialLevel, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", acmanajerialUpdate, {
            body: query
        }, true)
    }

    fetchCategories = async (query) => {
        return await apiRequest("get", masterCategories, {
            params: query
        }, true)
    }
}

export default UpdateRepository